/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 * Dyrektywa do obsługi autocomplete z danyh GUS'u
 *
 */

app.directive('teryt', function () {
	return {
		restrict: 'E',
		scope: {
			tState: '=', //wojewodztwo
			tCounty: '=',	//model powiatu - {
			//name: zawierać będzie nazwę powiatu lub null,
			//disabled: czy zablokowane,
			//required: czy wymagane
			//county_id: opcjonalne id powiatu, wymagane jeżeli podano nazwę
			//}
			tComunity: '=',	//model gminy - {
			//name: zawierać będzie nazwę gminy lub null,
			//disabled: czy zablokowane,
			//required: czy wymagane
			//comunity_id: opcjonalne id gminy, wymagane jeżeli podano nazwę
			//},
			tCity: '=',		//model miasta - {
			//name: zawierać będzie nazwę miasta lub null,
			//disabled: czy zablokowane,
			//required: czy wymagane
			//}
			tStreet: '=?'   //model ulicy - {
			//name: zawierać będzie nazwę ulicy lub null,
			//disabled: czy zablokowane,
			//required: czy wymagane
			//}, jeżeli nie podany ulica nie będzie wyświetlana
		},
		templateUrl: "/assets/js/angular/components/directives/teryt/teryt.html",
		link: function (scope) {			
			scope.show_street = typeof scope.tStreet !== 'undefined';
		}
	};
});
